import React, { useEffect } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Philosophy } from './components/Philosophy';
import { Services } from './components/Services';
import { Programs } from './components/Programs';
import { Pricing } from './components/Pricing';
import { AboutCoach } from './components/AboutCoach';
import { Testimonials } from './components/Testimonials';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  // Enable smooth scrolling for anchor links
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);
  return <div className="min-h-screen bg-sep-offwhite font-sans text-sep-charcoal selection:bg-sep-red selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Philosophy data-id="element-4" />
        <Services data-id="element-5" />
        <Programs data-id="element-6" />
        <Pricing data-id="element-7" />
        <AboutCoach data-id="element-8" />
        <Testimonials data-id="element-9" />
        <Contact data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}